// socket.io `auth` for our middleware gateways.
//
// Function form on purpose: socket.io calls it on EVERY (re)connect, while an
// object literal is sent unchanged forever — so a socket that reconnected
// after the access token was renewed kept presenting the expired one.
// Always the "Bearer <jwt>" shape WsAuthGuard parses (`auth.token.split(" ")[1]`):
// a bare JWT has no space and authenticates as nobody.
export function bearerSocketAuth(readToken) {
  return (cb) => {
    const token = readToken ? readToken() : null;
    cb(token ? { token: "Bearer " + token } : {});
  };
}
